module.exports = __webpack_public_path__ + "img/sign-fail.05baaf04.png";